/**
 * Web Style Import
 *
 */

import './dnb-wizard-layout.scss'
